import {combineReducers} from 'redux';
import officeReducer from '_app/shared/features/officeSettings/officeSettingsReducer';
import campaignPagePreviewReducer from './scenes/CampaignPagePreview/campaignPagePreviewReducer';
import htmlMediaContentReducer from './scenes/MediaShare/components/HtmlMediaContent/htmlMediaContentReducer';

export default combineReducers({
	office: officeReducer,
	campaignPagePreview : campaignPagePreviewReducer,
	htmlContent: htmlMediaContentReducer
});